const dtGenerator   = require ('../../../../../components/dt/dt-generator')
const dtHandler     = require ('../../../../../components/dt/dt-handler')
const dtSearch      = require ('../../../../../components/dt/dt-search')
const inf            = require('../../../../../js-network/inf')
const purchaseMenu  = require('./purchase-menu')
const {organizeRow} = require('./purchase-dt-handler')
const {tableDetail} = require('./purchase-dt-handler')
const {createChart} = require('./chart/purchase-chart')

/****************ELEMENTS*****************/
var htmlDt = {}
var HTMLwasSelected = false
const INITIAL_ROWS = 20

function HTMLselect(){ 

      dtHandler.HTMLselect('purchase-dt', htmlDt, organizeRow, tableDetail)
      HTMLwasSelected  = true
            
}/**/
/****************ELEMENTS*****************/

export function start(detail){  //console.log('purchase-dt 5>', detail)
  
      if(!HTMLwasSelected) { HTMLselect() }
       
      obj[detail.act].start(detail)

}/**/

const obj = {
   
      //From fullcont connection    
      addRow:         { start: (detail)=>{  dtGenerator.addRow( detail, htmlDt  )         }},
      tableOptions:   { start: (detail)=>{  purchaseMenu.start(detail, htmlDt, 'htmlFc')  }},
      trMenu:         { start: (detail)=>{  purchaseMenu.start(detail, htmlDt, 'htmlFc')  }},
      updateRow:      { start: (detail)=>{  dtGenerator.updateRow(detail, htmlDt)         }},
      //data table
      filter:         { start: (detail)=>{  dtSearch.filter(detail, htmlDt )              }},
      filterShowHide: { start: (detail)=>{  dtSearch.filterShowHide(detail, htmlDt )      }},
      loadMore:       { start: (detail)=>{  dtSearch.loadMore(detail, htmlDt )            }},
      searching:      { start: (detail)=>{  dtSearch.searching(detail, htmlDt )           }},
      select:         { start: (detail)=>{  selectInitial(detail)                          }},
      th:             { start: (detail)=>{  dtSearch.th(detail, htmlDt )                  }},
      trPrint:        { start: (detail)=>{  trPrint(detail)                               }},
      dtReport:       { start: (detail)=>{  dtReport(detail)                              }},

}/**/

function selectInitial(detail) {
      inf.toSelect(detail, htmlDt)
      detail.inf.limit2 = INITIAL_ROWS
      dtSearch.select(detail, htmlDt, true, (result) => {
            htmlDt.footer.setAttribute('data-limit', 10)
            // fillChart(result)
      })
      detail.inf.limit2 = 10
}

async function fillChart(result){
      if(!result || !result[0] || !result[0].charts) { return; }

      const data = JSON.parse(result[0].charts)
      const dataChart = data[0].data

      createChart(dataChart)

}

function trPrint (detail){ }//console.log(' trPrint>')   }
